var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { selectSystemByIndexArray } from "../../stateTree";
import { FileType } from "../../../";
import { removeRepresentation } from "../utils";
import { addRepresentation } from "../../showFile";
import { dispatchNotificationEvent } from "../../../NotificationSystem/utils";
import { replaceMolstarParams } from "../../../3dViewer/SelectVolumeParams";
import { getActiveSystemEntries } from "../../../utils/IndexSelector/indexSelectorToIndexArray";
function cloneRepresentationsVolume(fromSystem, loaded_structures, toPositionInTreeArr, vss, molstar, pyodide) {
    var _a, toPositionInTreeArr_1, toPositionInTreeArr_1_1;
    var _b, e_1, _c, _d;
    return __awaiter(this, void 0, void 0, function* () {
        const fromReps = fromSystem.volumeRepresentation
            ? fromSystem.volumeRepresentation
            : {};
        const skipped = [];
        try {
            for (_a = true, toPositionInTreeArr_1 = __asyncValues(toPositionInTreeArr); toPositionInTreeArr_1_1 = yield toPositionInTreeArr_1.next(), _b = toPositionInTreeArr_1_1.done, !_b;) {
                _d = toPositionInTreeArr_1_1.value;
                _a = false;
                try {
                    const toPositionInTree = _d;
                    const toSystem = selectSystemByIndexArray(toPositionInTree, loaded_structures);
                    if (!toSystem)
                        continue;
                    if (toSystem.moleculeID === fromSystem.moleculeID)
                        continue;
                    if (toSystem.type !== FileType.volume) {
                        skipped.push(toSystem.name);
                        continue;
                    }
                    const cellRef = toSystem.cellRef && toSystem.cellRef.length > 0
                        ? toSystem.cellRef[0]
                        : undefined;
                    if (!cellRef)
                        continue;
                    replaceMolstarParams(molstar, cellRef, fromReps);
                    vss.getState().updateSystemParameters(toPositionInTree, {
                        volumeRepresentation: fromReps,
                    });
                }
                finally {
                    _a = true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (!_a && !_b && (_c = toPositionInTreeArr_1.return)) yield _c.call(toPositionInTreeArr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (skipped.length > 0) {
            dispatchNotificationEvent({
                message: `It was not possible to clone representations to the following systems: ${skipped.join(" ")}. Wrong type.`,
                type: "warning",
            });
        }
    });
}
function cloneRepresentationsStructures(fromSystem, loaded_structures, toPositionInTreeArr, vss, molstar, pyodide) {
    var _a, toPositionInTreeArr_2, toPositionInTreeArr_2_1;
    var _b, e_2, _c, _d;
    var _e;
    return __awaiter(this, void 0, void 0, function* () {
        const fromReps = fromSystem.representations;
        const skipped = [];
        try {
            for (_a = true, toPositionInTreeArr_2 = __asyncValues(toPositionInTreeArr); toPositionInTreeArr_2_1 = yield toPositionInTreeArr_2.next(), _b = toPositionInTreeArr_2_1.done, !_b;) {
                _d = toPositionInTreeArr_2_1.value;
                _a = false;
                try {
                    const toPositionInTree = _d;
                    const toSystem = selectSystemByIndexArray(toPositionInTree, loaded_structures);
                    if (!toSystem)
                        continue;
                    if (toSystem.moleculeID === fromSystem.moleculeID)
                        continue;
                    if (toSystem.type === FileType.volume) {
                        skipped.push(toSystem.name);
                        continue;
                    }
                    const repRefs = ((_e = toSystem.representations) === null || _e === void 0 ? void 0 : _e.flatMap((rep) => {
                        var _a;
                        return (((_a = rep.refs) === null || _a === void 0 ? void 0 : _a.map((ref) => ref.repRef)) || []).filter((ref) => ref !== undefined);
                    })) || [];
                    removeRepresentation(vss, molstar, repRefs, undefined, 0, false);
                    const activeSystemEntries = getActiveSystemEntries(toSystem);
                    const addedReps = yield addRepresentation(molstar, pyodide, toSystem.type === FileType.sdf, toSystem.moleculeID ? toSystem.moleculeID : "", toSystem.type === FileType.sdf, undefined, toSystem.cellRef, toSystem.visibility, fromReps, toSystem.aromaticBonds, activeSystemEntries);
                    vss
                        .getState()
                        .updateSystemParameters(toPositionInTree, { representations: addedReps });
                }
                finally {
                    _a = true;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (!_a && !_b && (_c = toPositionInTreeArr_2.return)) yield _c.call(toPositionInTreeArr_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (skipped.length > 0) {
            dispatchNotificationEvent({
                message: `It was not possible to clone representations to the following systems: ${skipped.join(" ")}. Wrong type.`,
                type: "warning",
            });
        }
    });
}
export function cloneRepresentationsToSystems(fromPositionInTree, toPositionInTreeArr, vss, molstar, pyodide) {
    return __awaiter(this, void 0, void 0, function* () {
        const loaded_structures = vss.getState().loaded_structures;
        const fromSystem = selectSystemByIndexArray(fromPositionInTree, loaded_structures);
        if (!fromSystem) {
            dispatchNotificationEvent({
                message: `Error obtaining original system representations.`,
                type: "warning",
            });
            return;
        }
        const fromIsVolume = fromSystem.type === FileType.volume;
        if (fromIsVolume) {
            yield cloneRepresentationsVolume(fromSystem, loaded_structures, toPositionInTreeArr, vss, molstar, pyodide);
        }
        else {
            yield cloneRepresentationsStructures(fromSystem, loaded_structures, toPositionInTreeArr, vss, molstar, pyodide);
        }
    });
}
